import httpConnection from "../api/httpconnection";

const headers = {
  "Content-Type": "application/json; charset=utf-8",
};

// -----------------------------
// Vendor Type
// -----------------------------
export async function saveOrUpdateVendorType(data) {
  const response = await httpConnection.post(
    `vendor-type/saveOrUpdateVendorType`,
    data,
    {
      headers: headers,
    },
  );
  return {
    response: response.data,
  };
}

export async function getAllVendorType(pageNo, pageSize) {
  const response = await httpConnection.get(
    `vendor-type/getAllVendorTypes?pageNo=${pageNo}&pageSize=${pageSize}`,
    {},
    { headers: headers },
  );
  return {
    response: response.data,
  };
}

export async function searchVendorTypeData(values, pageNo, pageSize) {
  const data = {
    name: values.searchName,
    status: values.searchStatus,
    pageNumber: pageNo,
    pageSize: pageSize,
  };

  const response = await httpConnection.post(
    `vendor-type/searchVendorType`,
    data,
    {
      headers: headers,
    },
  );

  const list = response?.data?.responseMap?.SEARCH_FORM_LIST;
  if (Array.isArray(list)) {
    const parsedResponse = list.map((item) => {
      return {
        vendorTypeId: item.vendor_type_id ?? item.vendorTypeId ?? item.id,
        name: item.name,
        code: item.code,
        description: item.description,
        status: item.status,
        isEvaluationRequired: item.isEvaluationRequired,
        createdBy: item.created_by ?? item.createdBy,
        createdDate: item.created_dt ?? item.createdDate,
        updatedBy: item.updated_by ?? item.updatedBy,
        updatedDate: item.updated_dt ?? item.updatedDate,
      };
    });

    response.data.responseMap.data = [...parsedResponse];
  }

  return response.data;
}

export async function getVendorEvaluationById(id) {
  const response = await httpConnection.get(
    `vendor-evaluation/getVendorEvaluationById?id=${id}`,
    {},
    { headers: headers },
  );
  return {
    response: response.data,
  };
}

export async function checkVendorEvaluationPanNoExists(panNo) {
  if (!panNo || typeof panNo !== "string" || panNo.trim() === "") {
    return { exists: false };
  }
  const params = new URLSearchParams({ panNo: panNo.trim() });
  const response = await httpConnection.get(
    `vendor-evaluation/checkPanNoExists?${params.toString()}`,
    {},
    { headers: headers },
  );
  const data = response?.data?.responseObject ?? response?.data ?? response;
  const exists =
    data?.exists === true ||
    data?.exists === "true" ||
    (typeof data === "boolean" && data);
  return { exists: Boolean(exists) };
}

export async function saveOrUpdateVendorEvaluation(data) {
  if (Array.isArray(data.category)) {
    data.category = data.category.join(",");
  }
  if (Array.isArray(data.referredFor)) {
    data.referredFor = data.referredFor.join(",");
  }
  const response = await httpConnection.post(
    `vendor-evaluation/saveOrUpdateVendorEvaluation`,
    data,

    {
      headers: headers,
    },
  );
  return {
    response: response.data,
  };
}

// -----------------------------
// Vendor Evaluation File Details (attachments / digital images)
// -----------------------------
export async function saveOrUpdateVendorEvaluationFileDetails(formData) {
  const response = await httpConnection.post(
    `vendor-evaluation-file-details/saveOrUpdateVendorEvaluationFileDetails`,
    formData,
  );
  return {
    response: response.data,
  };
}

export async function getAllVendorEvaluationList(pageNo, pageSize) {
  const response = await httpConnection.get(
    `vendor-evaluation/getAllVendorEvaluationList?pageNo=${pageNo}&pageSize=${pageSize}`,
    {},
    { headers: headers },
  );
  return {
    response: response.data,
  };
}

export async function searchVendorEvaluationListData(values, pageNo, pageSize) {
  const data = {
    isExistingUser: values.searchIsExistingUser,
    factoryName: values.searchFactoryName,
    vendorCode: values.searchVendorCode,
    pageNumber: pageNo,
    pageSize: pageSize,
  };

  const response = await httpConnection.post(
    `vendor-evaluation/searchVendorEvaluationList`,
    data,
    {
      headers: headers,
    },
  );

  const list =
    response?.data?.responseObject ??
    response?.data?.responseMap?.SEARCH_FORM_LIST;
  if (Array.isArray(list)) {
    const parsedResponse = list.map((item) => {
      return {
        vendorEvaluationListId:
          item.vendor_evaluation_id ?? item.vendorEvaluationId ?? item.id,
        factoryName: item.factory_name ?? item.factoryName,

        vendorCode: item.vendor_code ?? item.vendorCode,

        ownerName: item.owner_name ?? item.ownerName,

        ownerContactNo: item.owner_contact_no ?? item.ownerContactNo,

        ownerEmail: item.owner_email ?? item.ownerEmail,

        isExistingUser: item.is_existing_user ?? item.isExistingUser,

        currentStep: item.current_step ?? item.currentStep,

        createdBy: item.created_by ?? item.createdBy,

        createdDate: item.created_dt ?? item.createdDate,

        updatedBy: item.updated_by ?? item.updatedBy,

        updatedDate: item.updated_dt ?? item.updatedDate,
      };
    });

    response.data.responseMap.data = [...parsedResponse];
  }

  return response.data;
}

export async function getAllVendorRegistrationList(pageNo, pageSize) {
  const response = await httpConnection.get(
    `vendor-registration/getAllVendorRegistrationList?pageNo=${pageNo}&pageSize=${pageSize}`,
    {},
    { headers: headers },
  );
  return {
    response: response.data,
  };
}

export async function searchVendorRegistrationListData(
  values,
  pageNo,
  pageSize,
) {
  const data = {
    name: values.searchName,
    vendorCode: values.searchVendorCode,
    regNo: values.searchRegNo,
    pageNumber: pageNo,
    pageSize: pageSize,
  };

  const response = await httpConnection.post(
    `vendor-registration/searchVendorRegistrationList`,
    data,
    {
      headers: headers,
    },
  );

  const list =
    response?.data?.responseObject ??
    response?.data?.responseMap?.SEARCH_FORM_LIST;
  if (Array.isArray(list)) {
    const parsedResponse = list.map((item) => {
      return {
        vendorRegistrationListId:
          item.vendor_registration_id ?? item.vendorRegistrationId ?? item.id,
        companyName: item.company_name ?? item.companyName,
        regNo: item.reg_no ?? item.regNo,
        vendorCode: item.vendor_code ?? item.vendorCode,
        vendorTypeCode: item.vendor_type_code ?? item.vendorTypeCode,
        vendorTypeName: item.vendor_type_name ?? item.vendorTypeName,
        ownerName: item.owner_name ?? item.ownerName,
        ownerContactNo: item.owner_contact_no ?? item.ownerContactNo,
        ownerEmail: item.owner_email ?? item.ownerEmail,
        createdBy: item.created_by ?? item.createdBy,
        createdDate: item.created_dt ?? item.createdDate,
        updatedBy: item.updated_by ?? item.updatedBy,
        updatedDate: item.updated_dt ?? item.updatedDate,
      };
    });

    if (!response.data.responseMap) {
      response.data.responseMap = {};
    }
    response.data.responseMap.data = [...parsedResponse];
  }

  return response.data;
}

export async function saveOrUpdateVendorRegistration(data) {
  if (Array.isArray(data.shareholdingStatus)) {
    data.shareholdingStatus = data.shareholdingStatus.join(",");
  }
  const response = await httpConnection.post(
    `vendor-registration/saveOrUpdateVendorRegistration`,
    data,

    {
      headers: headers,
    },
  );
  return {
    response: response.data,
  };
}

export async function saveOrUpdateVendorAmendment(data) {
  if (Array.isArray(data.shareholdingStatus)) {
    data.shareholdingStatus = data.shareholdingStatus.join(",");
  }
  const createdBy = JSON.parse(sessionStorage.getItem("userData") || "{}")
    ?.username;
  const payload = {
    ...data,
    createdBy: createdBy || data?.createdBy || "",
  };
  const response = await httpConnection.post(
    `vendor-amendment/saveOrUpdateVendorAmendment`,
    payload,
    {
      headers: headers,
    },
  );
  return {
    response: response.data,
  };
}

export async function getVendorAmendmentByVendorRegistrationId(
  vendorRegistrationId,
) {
  const response = await httpConnection.get(
    `vendor-amendment/getVendorAmendmentByVendorRegistrationId?vendorRegistrationId=${vendorRegistrationId}`,
    {},
    { headers: headers },
  );
  return {
    response: response.data,
  };
}

export async function getAllVendorAmendmentList(pageNo, pageSize) {
  const response = await httpConnection.get(
    `vendor-amendment/getAllVendorAmendmentList?pageNo=${pageNo}&pageSize=${pageSize}`,
    {},
    { headers: headers },
  );
  return {
    response: response.data,
  };
}

export async function searchVendorAmendmentListData(
  values,
  pageNo,
  pageSize,
) {
  const data = {
    name: values.searchName,
    vendorCode: values.searchVendorCode,
    amendmentNo: values.searchAmendmentNo,
    pageNumber: pageNo,
    pageSize: pageSize,
  };

  const response = await httpConnection.post(
    `vendor-amendment/searchVendorAmendmentList`,
    data,
    { headers: headers },
  );

  return {
    response: response.data,
  };
}

export async function exportToExcelVendorAmendmentList(searchData, dateTime) {
  try {
    const params = new URLSearchParams({
      dateTime: dateTime ?? "",
    });
    if (searchData?.searchName) {
      params.append("searchName", searchData.searchName);
    }
    if (searchData?.searchVendorCode) {
      params.append("searchVendorCode", searchData.searchVendorCode);
    }
    if (searchData?.searchAmendmentNo) {
      params.append("searchAmendmentNo", searchData.searchAmendmentNo);
    }

    const response = await httpConnection.get(
      `vendor-amendment/export-to-excel?${params.toString()}`,
      {
        responseType: "arraybuffer",
      },
    );
    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `Vendor_Amendment_Review_${dateTime}.xlsx`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error exporting vendor amendment list to Excel:", error);
    throw error;
  }
}

export async function getVendorAmendmentById(id) {
  const response = await httpConnection.get(
    `vendor-amendment/getVendorAmendmentById?id=${id}`,
    {},
    { headers: headers },
  );
  return {
    response: response.data,
  };
}

export async function updateVendorAmendmentStatus(data) {
  const updatedBy =
    JSON.parse(sessionStorage.getItem("userData") || "{}")?.username || "ADMIN";
  const payload = {
    ...data,
    updatedBy: updatedBy,
  };
  const response = await httpConnection.post(
    `vendor-amendment/updateVendorAmendmentStatus`,
    payload,
    {
      headers: headers,
    },
  );
  return {
    response: response.data,
  };
}

export async function updateTermsAndConditions(data) {
  const response = await httpConnection.post(
    `vendor-registration/updateTermsAndConditions`,
    data,
    {
      headers: headers,
    },
  );
  return {
    response: response.data,
  };
}

export async function updateCOBC(data) {
  const response = await httpConnection.post(
    `vendor-registration/updateCOBC`,
    data,
    {
      headers: headers,
    },
  );
  return {
    response: response.data,
  };
}



export async function vendorRegistrationSendInvite(data) {
  const createdBy = JSON.parse(sessionStorage.getItem("userData") || "{}")?.username;
  const payload = {
    ...data,
    createdBy: createdBy || data?.createdBy || "",
  };
  const response = await httpConnection.post(
    `vendor-registration/vendorRegistrationSendInvite`,
    payload,
    {
      headers: headers,
    },
  );
  return {
    response: response.data,
  };
}

export async function getVendorRegistrationById(id) {
  const response = await httpConnection.get(
    `vendor-registration/getVendorRegistrationById?id=${id}`,
    {},
    { headers: headers },
  );
  return {
    response: response.data,
  };
}

/** fieldType: PAN | GST | ACCOUNT | OWNER_CONTACT */
export async function checkVendorRegistrationStatutoryDuplicate(
  fieldType,
  value,
  excludeVendorRegistrationId,
) {
  if (!value || typeof value !== "string" || value.trim() === "") {
    return { exists: false };
  }
  const params = new URLSearchParams({
    fieldType: String(fieldType).trim().toUpperCase(),
    value: value.trim(),
  });
  if (
    excludeVendorRegistrationId != null &&
    excludeVendorRegistrationId !== ""
  ) {
    params.append(
      "excludeVendorRegistrationId",
      String(excludeVendorRegistrationId),
    );
  }
  const response = await httpConnection.get(
    `vendor-registration/checkStatutoryDuplicate?${params.toString()}`,
    {},
    { headers: headers },
  );
  const data = response?.data?.responseObject ?? response?.data ?? response;
  const exists =
    data?.exists === true ||
    data?.exists === "true" ||
    (typeof data === "boolean" && data);
  return { exists: Boolean(exists) };
}

export async function checkVendorRegistrationPanNoExists(
  panNo,
  excludeVendorRegistrationId,
) {
  return checkVendorRegistrationStatutoryDuplicate(
    "PAN",
    panNo,
    excludeVendorRegistrationId,
  );
}

export async function uploadVendorEvaluationFile(
  vendorEvaluationId,
  fileType,
  file,
) {
  const formData = new FormData();

  formData.append("vendorEvaluationId", vendorEvaluationId);
  formData.append("fileType", fileType);
  formData.append("file", file);

  const response = await httpConnection.post(
    "vendor-evaluation/uploadVendorFile",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );

  return response.data;
}

export async function getAllLedger(
  vendorCode,
  pageNo,
  pageSize,
  searchDate,
  groupId,
  documentType,
) {
  const docType =
    documentType != null && documentType !== "" ? documentType : "";
  const response = await httpConnection.get(
    `ledgerAp/getAllLedgerAp?vendorCode=${vendorCode}&pageNo=${pageNo}&pageSize=${pageSize}&searchDate=${searchDate}&groupId=${groupId}&documentType=${encodeURIComponent(docType)}`,
    {},
    { headers: headers },
  );

  return {
    response: response.data,
  };
}

export async function updateLedgerApVendorFields(ledgerApId, payload) {
  const data = {
    ledgerApId: ledgerApId ?? payload.ledgerApId,
    vendorInvoiceValue: payload.vendorInvoiceValue,
    vendorPaymentReceiptValue: payload.vendorPaymentReceiptValue,
    gstReturnFilingStatus: payload.gstReturnFilingStatus,
    vendorRemarks: payload.vendorRemarks,
  };
  const response = await httpConnection.post("ledgerAp/updateLedgerAp", data, {
    headers: headers,
  });
  return { response: response.data };
}

// vendorCode: pass vendorCode; vendorName: pass vendorName
export async function importLedgerApExcel(file) {
  const formData = new FormData();
  formData.append("file", file);
  const response = await httpConnection.post(
    "ledgerAp/import-from-excel",
    formData,
  );
  return { response: response.data };
}

export async function uploadVendorDocument(vendorCode, remarks, file, createdBy) {
  const formData = new FormData();
  formData.append("vendorCode", vendorCode ?? "");
  formData.append("remarks", remarks ?? "");
  formData.append("createdBy", createdBy ?? "");
  formData.append("file", file);
  const response = await httpConnection.post(
    "vendor-document-upload/upload",
    formData,
  );
  return { response: response.data };
}

export async function getAllVendorDocumentUploadList(pageNo, pageSize) {
  const response = await httpConnection.get(
    `vendor-document-upload/getAllVendorDocumentUploadList?pageNo=${pageNo}&pageSize=${pageSize}`,
    {},
    { headers: headers },
  );
  return { response: response.data };
}

export async function replyVendorDocument(payload) {
  const response = await httpConnection.post(
    "vendor-document-upload/reply",
    payload,
    { headers: headers },
  );
  return { response: response.data };
}

export async function exportToExcelLedger(
  vendorCode,
  customerName,
  dateTime,
  financialYear,
  groupId,
  documentType,
) {
  try {
    const docType =
      documentType != null && documentType !== "" ? documentType : "";
    const response = await httpConnection.get(
      `ledgerAp/export-to-excel?vendorCode=${vendorCode}&customerName=${customerName}&dateTime=${dateTime}&financialYear=${financialYear}&groupId=${groupId}&documentType=${encodeURIComponent(docType)}`,
      {
        responseType: "arraybuffer",
      },
    );
    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `Ledger_report_${dateTime}.xlsx`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error exporting to Excel:", error);
  }
}

// vendorCode: pass vendorCode; vendorName: pass vendorName
export async function exportToPDFLedger(
  vendorCode,
  customerName,
  dateTime,
  financialYear,
  groupId,
  documentType,
) {
  try {
    const docType =
      documentType != null && documentType !== "" ? documentType : "";
    const response = await httpConnection.get(
      `ledgerAp/export-to-pdf?vendorCode=${vendorCode}&customerName=${customerName}&dateTime=${dateTime}&financialYear=${financialYear}&groupId=${groupId}&documentType=${encodeURIComponent(docType)}`,
      {
        responseType: "arraybuffer",
      },
    );
    const blob = new Blob([response.data], {
      type: "application/pdf",
    });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `Ledger_report_${dateTime}.pdf`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error exporting to PDF:", error);
  }
}

export async function exportToPDFLedgerApOpenDebit(
  vendorCode,
  ledgerApDTO,
  dateTime,
) {
  try {
    const response = await httpConnection.get(
      `ledgerAp/exportPdfOpenDebit?vendorCode=${vendorCode}&ledgerApId=${ledgerApDTO.ledgerApId}&dateTime=${dateTime}`,
      {
        responseType: "arraybuffer",
      },
    );
    const blob = new Blob([response.data], {
      type: "application/pdf",
    });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `LedgerOpenDebit_report_${dateTime}.pdf`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error exporting to PDF:", error);
  }
}

export async function updateVendorPassword(loginUserId, loginPin) {
  const response = await httpConnection.put(
    `vendor-registration/update-vendor-password`,
    {
      vendorRegistrationId: loginUserId,
      password: loginPin,
    },
    {
      headers: headers,
    },
  );
  return {
    response: response.data,
  };
}

export async function exportToPDFLedgerApPaymentAdvice(
  vendorCode,
  ledgerApDTO,
  dateTime,
) {
  try {
    const response = await httpConnection.get(
      `ledgerAp/exportPdfPaymentAdvice?vendorCode=${vendorCode}&ledgerApId=${ledgerApDTO.ledgerApId}&documentNumber=${ledgerApDTO.documentNumber}&dateTime=${dateTime}`,
      {
        responseType: "arraybuffer",
      },
    );
    const blob = new Blob([response.data], {
      type: "application/pdf",
    });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `LedgerPaymentAdvice_report_${dateTime}.pdf`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error exporting to PDF:", error);
  }
}

export async function saveOrUpdateDocumentType(data) {
  const response = await httpConnection.post(
    `document-type/saveOrUpdateDocumentType`,
    data,
    {
      headers: headers,
    },
  );
  return {
    response: response.data,
  };
}

export async function getAllDocumentType(pageNo, pageSize) {
  const response = await httpConnection.get(
    `document-type/getAllDocumentTypes?pageNo=${pageNo}&pageSize=${pageSize}`,
    {},
    { headers: headers },
  );
  return {
    response: response.data,
  };
}

export async function searchDocumentTypeData(values, pageNo, pageSize) {
  const data = {
    name: values.searchName,
    code: values.searchCode,
    pageNumber: pageNo,
    pageSize: pageSize,
  };

  const response = await httpConnection.post(
    `document-type/searchDocumentType`,
    data,
    {
      headers: headers,
    },
  );

  const list =
    response?.data?.responseObject ??
    response?.data?.responseMap?.SEARCH_FORM_LIST ??
    response?.data?.responseMap?.data;
  if (!response.data.responseMap) {
    response.data.responseMap = {};
  }
  if (Array.isArray(list)) {
    const parsedResponse = list.map((item) => {
      return {
        documentTypeId: item.document_type_id ?? item.documentTypeId ?? item.id,
        name: item.name,
        code: item.code,
        createdBy: item.created_by ?? item.createdBy,
        createdDate: item.created_dt ?? item.createdDate,
        updatedBy: item.updated_by ?? item.updatedBy,
        updatedDate: item.updated_dt ?? item.updatedDate,
      };
    });
    response.data.responseMap.data = [...parsedResponse];
  } else {
    response.data.responseMap.data = [];
  }

  return response.data;
}

export async function saveOrUpdateOffsetGlType(data) {
  const response = await httpConnection.post(
    `offsetGl-Type/saveOrUpdateOffsetGlType`,
    data,
    {
      headers: headers,
    },
  );
  return {
    response: response.data,
  };
}

export async function getAllOffsetGlType(pageNo, pageSize) {
  const response = await httpConnection.get(
    `offsetGl-Type/getAllOffsetGlType?pageNo=${pageNo}&pageSize=${pageSize}`,
    {},
    { headers: headers },
  );
  return {
    response: response.data,
  };
}

export async function searchOffsetGlTypeData(values, pageNo, pageSize) {
  const data = {
    name: values.searchName,
    code: values.searchCode,
    pageNumber: pageNo,
    pageSize: pageSize,
  };

  const response = await httpConnection.post(
    `offsetGl-Type/searchOffsetGlType`,
    data,
    {
      headers: headers,
    },
  );

  const list = response?.data?.responseMap?.SEARCH_FORM_LIST;
  if (Array.isArray(list)) {
    const parsedResponse = list.map((item) => {
      return {
        offsetGlTypeId:
          item.offset_gl_type_id ?? item.offsetGlTypeId ?? item.id,
        name: item.name,
        code: item.code,
        createdBy: item.created_by ?? item.createdBy,
        createdDate: item.created_dt ?? item.createdDate,
        updatedBy: item.updated_by ?? item.updatedBy,
        updatedDate: item.updated_dt ?? item.updatedDate,
      };
    });

    response.data.responseMap.data = [...parsedResponse];
  }

  return response.data;
}

export async function getAllVendorRegistrationHistory(
  pageNo,
  pageSize,
  vendorRegistrationId,
) {
  const id =
    vendorRegistrationId != null && vendorRegistrationId !== ""
      ? `&vendorRegistrationId=${encodeURIComponent(vendorRegistrationId)}`
      : "";
  const response = await httpConnection.get(
    `vendor-registration/getAllVendorRegistrationHistory?pageNo=${pageNo}&pageSize=${pageSize}${id}`,
    {},
    { headers: headers },
  );
  return {
    response: response.data,
  };
}




export async function exportToExcelVendorRegistration(
  vendorCode,
  vendorName,
  dateTime,
  groupId,
  companyName = "",
  regNo = "",
) {
  try {
    const params = new URLSearchParams({
      vendorCode: vendorCode ?? "",
      vendorName: vendorName ?? "",
      dateTime: dateTime ?? "",
      groupId: groupId ?? "",
    });
    if (companyName) {
      params.append("companyName", companyName);
    }
    if (regNo) {
      params.append("regNo", regNo);
    }

    const response = await httpConnection.get(
      `vendor-registration/export-to-excel?${params.toString()}`,
      {
        responseType: "arraybuffer",
      },
    );
    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
        a.download = `Vendor_Registration_${dateTime}.xlsx`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error exporting vendor registration to Excel:", error);
  }
}

export async function exportToPDFVendorRegistration(
  vendorRegistrationId,
  companyName,
  dateTime,
) {
  try {
    const params = new URLSearchParams({
      vendorRegistrationId: vendorRegistrationId ?? "",
      dateTime: dateTime ?? "",
    });
    const response = await httpConnection.get(
      `vendor-registration/export-to-pdf?${params.toString()}`,
      {
        responseType: "arraybuffer",
      },
    );
    const blob = new Blob([response.data], {
      type: "application/pdf",
    });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `Vendor_Registration_${companyName || "report"}_${dateTime}.pdf`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error exporting vendor registration to PDF:", error);
  }
}


export async function exportToExcelVendorRegistrationSAP(
  vendorCode,
  vendorName,
  dateTime,
  groupId,
  companyName = "",
  regNo = "",
) {
  try {
    const params = new URLSearchParams({
      vendorCode: vendorCode ?? "",
      vendorName: vendorName ?? "",
      dateTime: dateTime ?? "",
      groupId: groupId ?? "",
    });
    if (companyName) {
      params.append("companyName", companyName);
    }
    if (regNo) {
      params.append("regNo", regNo);
    }

    const response = await httpConnection.get(
      `vendor-registration/export-to-excelSAP?${params.toString()}`,
      {
        responseType: "arraybuffer",
      },
    );
    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
        a.download = `Vendor_Registration_SAP_${dateTime}.xlsx`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error exporting vendor registration SAP to Excel:", error);
  }
}

export async function saveOrUpdatePaymentTerms(data) {
  const response = await httpConnection.post(
    `payment-terms/saveOrUpdatePaymentTerms`,
    data,
    {
      headers: headers,
    },
  );
  return {
    response: response.data,
  };
}

export async function getAllPaymentTerms(pageNo, pageSize) {
  const response = await httpConnection.get(
    `payment-terms/getAllPaymentTerms?pageNo=${pageNo}&pageSize=${pageSize}`,
    {},
    { headers: headers },
  );
  return {
    response: response.data,
  };
}

export async function getAllReconGroups() {
  const response = await httpConnection.get(
    `recon-group/getAllReconGroups`,
    {},
    { headers: headers },
  );
  return {
    response: response.data,
  };
}

export async function getAllSubReconGroups() {
  const response = await httpConnection.get(
    `recon-group/getAllSubReconGroups`,
    {},
    { headers: headers },
  );
  return {
    response: response.data,
  };
}

export async function searchPaymentTermsData(values, pageNo, pageSize) {
  const data = {
    name: values.searchName,
    code: values.searchCode,
    pageNumber: pageNo,
    pageSize: pageSize,
  };

  const response = await httpConnection.post(
    `payment-terms/searchPaymentTerms`,
    data,
    {
      headers: headers,
    },
  );

  const list =
    response?.data?.responseObject ??
    response?.data?.responseMap?.SEARCH_FORM_LIST ??
    response?.data?.responseMap?.data;
  if (!response.data.responseMap) {
    response.data.responseMap = {};
  }
  if (Array.isArray(list)) {
    const parsedResponse = list.map((item) => {
      return {
        paymentTermsId: item.document_type_id ?? item.paymentTermsId ?? item.id,
        name: item.name,
        code: item.code,
        createdBy: item.created_by ?? item.createdBy,
        createdDate: item.created_dt ?? item.createdDate,
        updatedBy: item.updated_by ?? item.updatedBy,
        updatedDate: item.updated_dt ?? item.updatedDate,
      };
    });
    response.data.responseMap.data = [...parsedResponse];
  } else {
    response.data.responseMap.data = [];
  }

  return response.data;
}

export async function getAllUnitInspectedBy() {
  const response = await httpConnection.get(
    `vendor-registration/getAllUnitInspectedBy`,
    {},
    { headers: headers },
  );
  return {
    response: response.data,
  };
}

// -----------------------------
// Vendor Bulk Invite
// -----------------------------
export async function getAllBulkInviteList(pageNo, pageSize) {
  const response = await httpConnection.get(
    `vendor-bulk-invite/list?pageNo=${pageNo}&pageSize=${pageSize}`,
    {},
    { headers: headers },
  );
  return {
    response: response.data,
  };
}

export async function searchBulkInviteList(searchData, pageNo, pageSize) {
  const data = {
    searchVendorCode: searchData.searchVendorCode,
    searchVendorName: searchData.searchVendorName,
    searchInviteStatus: searchData.searchInviteStatus,
    pageNumber: pageNo,
    pageSize: pageSize,
  };

  const response = await httpConnection.post(
    `vendor-bulk-invite/search`,
    data,
    {
      headers: headers,
    },
  );

  const list = response?.data?.responseMap?.SEARCH_FORM_LIST;
  const totalCount = response?.data?.responseMap?.TOTAL_COUNT;
  const pageSize2 = response?.data?.responseMap?.PAGE_SIZE;

  return {
    response: {
      responseObject: list,
      responseMap: {
        totalCount: totalCount,
        pageSize: pageSize2,
      },
    },
  };
}

export async function getVendorsByType(vendorTypeId, pageNo = 0, pageSize = 9999) {
  const response = await httpConnection.get(
    `vendor-bulk-invite/vendors-by-type?vendorTypeId=${vendorTypeId}&pageNo=${pageNo}&pageSize=${pageSize}`,
    {},
    { headers: headers },
  );
  return {
    response: response.data,
  };
}

export async function sendBulkInvite(selectedVendorIds, inviteType) {
  const createdBy = JSON.parse(sessionStorage.getItem("userData") || "{}")?.username || "ADMIN";
  const data = {
    vendorRegistrationIds: selectedVendorIds,
    createdBy: createdBy,
    inviteType: inviteType,
  };

  const response = await httpConnection.post(
    `vendor-bulk-invite/send`,
    data,
    {
      headers: headers,
    },
  );
  return {
    response: response.data,
  };
}

export async function resendBulkInvite(bulkInviteId) {
  const updatedBy = JSON.parse(sessionStorage.getItem("userData") || "{}")?.username || "ADMIN";
  const response = await httpConnection.post(
    `vendor-bulk-invite/resend?bulkInviteId=${bulkInviteId}&updatedBy=${updatedBy}`,
    {},
    {
      headers: headers,
    },
  );
  return {
    response: response.data,
  };
}

export async function getBulkInviteStatistics() {
  const headers = {
    "Content-Type": "application/json",
  };
  const response = await httpConnection.get(
    `vendor-bulk-invite/statistics`,
    {
      headers: headers,
    },
  );
  return {
    response: response.data,
  };
}

export async function exportToExcelBulkInviteList(searchData, dateTime) {
  try {
    const params = new URLSearchParams({
      dateTime: dateTime ?? "",
    });
    if (searchData?.searchVendorCode) {
      params.append("searchVendorCode", searchData.searchVendorCode);
    }
    if (searchData?.searchVendorName) {
      params.append("searchVendorName", searchData.searchVendorName);
    }
    if (searchData?.searchInviteStatus) {
      params.append("searchInviteStatus", searchData.searchInviteStatus);
    }

    const response = await httpConnection.get(
      `vendor-bulk-invite/export-to-excel?${params.toString()}`,
      {
        responseType: "arraybuffer",
      },
    );
    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `Bulk_Invite_List_${dateTime}.xlsx`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error exporting bulk invite list to Excel:", error);
    throw error;
  }
}

export async function updateVendorContactDetails(vendorRegistrationId, ownerEmail, ownerContactNo, primaryEmail, primaryContact) {
  const updatedBy = JSON.parse(sessionStorage.getItem("userData") || "{}")?.username || "ADMIN";
  const data = {
    vendorRegistrationId: vendorRegistrationId,
    ownerEmail: ownerEmail,
    ownerContactNo: ownerContactNo,
    primaryEmail: primaryEmail,
    primaryContact: primaryContact,
    updatedBy: updatedBy,
  };

  const response = await httpConnection.put(
    `vendor-bulk-invite/update-contact-details`,
    data,
    {
      headers: headers,
    },
  );
  return {
    response: response.data,
  };
}